import { useEffect, useState } from 'react';
import '../style/style.css';

import '../fonts/verdana.ttf';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';

import Login from './Login';
import ResetPassword from './ResetPassword';
import PrivateRoute from './PrivateRoute';
import PrivateRouteCliente from './PrivateRouteCliente';
import AppContent from './AppContent';
import Homepage from './Homepage';
import Clienti from './Clienti';
import DettaglioLavoratore from './DettaglioLavoratore/DettaglioLavoratore';
import Medici from './Medici';
import DettaglioMedico from './DettaglioMedico';
import VisiteMediche from './VIsiteMediche';
import Allegati3B from './Allegati3B';
import Idoneita from './Idoneita';
import PrefatturazioneMedicina from './PrefatturazioneMedicina';
import AnagraficaCorsi from './AnagraficaCorsi';
import Formatori from './Formatori';
import Scadenzario from './ScadenzarioCorsi';
import AuleCorsi from './AuleCorsi';
import CorsiAttestati from './CorsiAttestati';
import PrefatturazioneCorsi from './PrefatturazioneCorsi';
import SetPassword from './SetPassword';
import Adempimenti from './Adempimenti';
import Anomalie from './Anomalie';
import { RiepilogativoVisite } from './RiepilogativoVisite';
import ScadenzarioVisite from './ScadenzarioVisite';
import LavoratoriSicurezza from './LavoratoriSicurezza';
import UtentiClienti from './UtentiClienti';
import Memo from './Memo';
import { CategoriaAdempimenti } from './CategoriaAdempimenti';
import ClientDetail from './ClientDetail';
import { LicenseInfo } from '@mui/x-data-grid-pro';
import MansioniSicurezza from './MansioniSicurezza';
import CollegaVirtuale from './CollegaVirtuale';
import { SediDetail } from './SediDetail';
import { AnagraficaRischi } from './AnagraficaRischi';
import { AnagraficaAccertamenti } from './AnagraficaAccertamenti';
import { AnagraficaMansioni } from './AnagraficaMansioni';
import { RiepilogativoFormazione } from './RiepilogativoFormazione';
import { AnagraficheDPI } from './AnagraficheDPI';
import Attrezzature from './Attrezzature';
import Miglioramenti from './Miglioramenti';

import 'react-toastify/dist/ReactToastify.css';

import Consumi from './Consumi';
import Distaccati from './Distaccati';
import UpdatePasswordLavoratore from './AccessoLavoratore/UpdatePasswordLavoratore';
import UpdatePasswordCliente from './UpdatePasswordCliente';
import LoginLavoratore from './AccessoLavoratore/LoginLavoratore';
import ResetPasswordLavoratore from './AccessoLavoratore/ResetPasswordLavoratore';
import ResetPasswordMedico from './AccessoMedico/ResetPasswordMedico';
import PrivateRouteLavoratore from './PrivateRouteLavoratore';
import AppContentLavoratori from './AccessoLavoratore/AppContentLavoratori';
import HomeLavoratori from './AccessoLavoratore/HomeLavoratori';
import AllegatiLavoratori from './AccessoLavoratore/AllegatiLavoratori';
import FormazioneLavoratore from './AccessoLavoratore/FormazioneLavoratore';
import MedicinaLavoratore from './AccessoLavoratore/MedicinaLavoratore';
import LoginMedico from './AccessoMedico/LoginMedico';
import PrivateRouteMedico from './PrivateRouteMedico';
import HomeMedico from './AccessoMedico/HomeMedico';
import AppContentMedico from './AccessoMedico/AppContentMedico';
import AllegatiMedici from './AccessoMedico/AllegatiMedici';
import VisiteMedici from './AccessoMedico/VisiteMedici';
import UpdatePasswordMedico from './AccessoMedico/updatePasswordMedico';
import moment from 'moment';
import { ProfiloLavoratore } from './AccessoLavoratore/ProfiloLavoratore';
import { ProfiloMedico } from './AccessoMedico/ProfiloMedico';
import DettaglioVisiteMedici from './AccessoMedico/DettaglioVisiteMedici';
import { TipologiePrestazioni } from './TipologiePrestazioni';
import AndamentoELearning from './AndamentoELearning';
import DiagnosticaELearning from './DiagnosticaELearning';
import DatiSensibiliLavoratore from './AccessoLavoratore/DatiSensibiliLavoratore';
import SicurezzaLavoratore from './AccessoLavoratore/SicurezzaLavoratori';
import CategorieCorsi from './CategorieCorsi';
import SetPasswordLavoratore from './AccessoLavoratore/SetPasswordLavoratore';
import SetPasswordMedico from './AccessoMedico/setPasswordMedico';
import NavigateSetter from '../utils/NavigateSetter';

moment.tz.setDefault('Europe/Rome');

//LICENZA MUI DATA GRID PRO
LicenseInfo.setLicenseKey(
    'd7d4e9b8c968c794c9b739b472716835Tz0xMjM5OTQsRT0xNzk5NDUyNzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI='
);

const App = () => {
    //Tengo tracciata il cambio grandezza della schermo
    const [screenSize, getDimension] = useState(window.innerWidth);
    const setDimension = () => {
        getDimension(window.innerWidth);
    };

    //Aggiorna valore grandezza schermo
    useEffect(() => {
        window.addEventListener('resize', setDimension);
    }, [screenSize]);
    return (
        <div>
            <BrowserRouter>
                <NavigateSetter />
                <Routes>
                    {
                        //#region Area Lavoratori
                    }
                    <Route
                        path="/AreaLavoratore/setPassword"
                        element={<SetPasswordLavoratore />}
                    />
                    <Route
                        path="/AreaLavoratore/updatePassword"
                        element={<UpdatePasswordLavoratore />}
                    />
                    <Route
                        path="/AreaLavoratore/Login"
                        element={<LoginLavoratore />}
                    />
                    <Route
                        path="/AreaLavoratore/reset-password"
                        element={<ResetPasswordLavoratore />}
                    />
                    <Route //AccessoLavoratore
                        path="/AreaLavoratore"
                        element={
                            <PrivateRouteCliente>
                                <AppContentLavoratori />
                            </PrivateRouteCliente>
                        }
                    >
                        <Route
                            path="/AreaLavoratore/Home"
                            element={
                                <PrivateRouteLavoratore>
                                    <HomeLavoratori />
                                </PrivateRouteLavoratore>
                            }
                        />
                        <Route
                            path="/AreaLavoratore/Documenti"
                            element={
                                <PrivateRouteLavoratore>
                                    <AllegatiLavoratori />
                                </PrivateRouteLavoratore>
                            }
                        />
                        <Route
                            path="/AreaLavoratore/Sicurezza"
                            element={
                                <PrivateRouteLavoratore>
                                    <SicurezzaLavoratore />
                                </PrivateRouteLavoratore>
                            }
                        />
                        <Route
                            path="/AreaLavoratore/Formazione"
                            element={
                                <PrivateRouteLavoratore>
                                    <FormazioneLavoratore />
                                </PrivateRouteLavoratore>
                            }
                        />
                        <Route
                            path="/AreaLavoratore/Medicina"
                            element={
                                <PrivateRouteLavoratore>
                                    <MedicinaLavoratore />
                                </PrivateRouteLavoratore>
                            }
                        />
                        <Route
                            path="/AreaLavoratore/DatiSensibili"
                            element={
                                <PrivateRouteLavoratore requireTwoFactor>
                                    <DatiSensibiliLavoratore />
                                </PrivateRouteLavoratore>
                            }
                        />
                        <Route
                            path="/AreaLavoratore/Profilo"
                            element={
                                <PrivateRouteLavoratore>
                                    <ProfiloLavoratore />
                                </PrivateRouteLavoratore>
                            }
                        />
                    </Route>
                    {
                        //#endregion
                    }

                    {
                        //#region Area Medico
                    }
                    <Route
                        path="/AreaMedico/setPassword"
                        element={<SetPasswordMedico />}
                    />
                    <Route
                        path="/AreaMedico/updatePassword"
                        element={<UpdatePasswordMedico />}
                    />
                    <Route
                        path="/AreaMedico/reset-password"
                        element={<ResetPasswordMedico />}
                    />
                    <Route path="/AreaMedico/Login" element={<LoginMedico />} />

                    <Route //AccessoMedico
                        path="/AreaMedico"
                        element={
                            <PrivateRouteMedico>
                                <AppContentMedico />
                            </PrivateRouteMedico>
                        }
                    >
                        <Route
                            path="/AreaMedico/Home"
                            element={
                                <PrivateRouteMedico>
                                    <HomeMedico />
                                </PrivateRouteMedico>
                            }
                        />
                        <Route
                            path="/AreaMedico/Documenti"
                            element={
                                <PrivateRouteMedico>
                                    <AllegatiMedici />
                                </PrivateRouteMedico>
                            }
                        />
                        <Route
                            path="/AreaMedico/Visita"
                            element={
                                <PrivateRouteMedico>
                                    <VisiteMedici />
                                </PrivateRouteMedico>
                            }
                        />
                        <Route
                            path="/AreaMedico/DettaglioVisitaMedico"
                            element={
                                <PrivateRouteMedico>
                                    <DettaglioVisiteMedici />
                                </PrivateRouteMedico>
                            }
                        />
                        <Route
                            path="/AreaMedico/Profilo"
                            element={
                                <PrivateRouteMedico>
                                    <ProfiloMedico />
                                </PrivateRouteMedico>
                            }
                        />
                    </Route>

                    {
                        //#endregion
                    }

                    {
                        //#region Area Generale
                    }

                    <Route path="/login" element={<Login />} />
                    <Route path="/setPassword" element={<SetPassword />} />
                    <Route
                        path="/updatePassword"
                        element={<UpdatePasswordCliente />}
                    />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route
                        path="/"
                        element={
                            <PrivateRoute>
                                <AppContent />
                            </PrivateRoute>
                        }
                    >
                        <Route
                            path="/"
                            element={<Homepage screenSize={screenSize} />}
                        />

                        <Route
                            path="/dettaglioAzienda"
                            element={
                                <PrivateRoute>
                                    <ClientDetail screenSize={screenSize} />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/categorie-corsi"
                            element={
                                <PrivateRoute>
                                    <CategorieCorsi screenSize={screenSize} />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/distaccati"
                            element={
                                <PrivateRoute>
                                    <Distaccati screenSize={screenSize} />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/dettaglioSedi"
                            element={
                                <PrivateRoute>
                                    <SediDetail screenSize={screenSize} />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/Consumi"
                            element={
                                <PrivateRoute>
                                    <Consumi screenSize={screenSize} />
                                </PrivateRoute>
                            }
                        />

                        <Route
                            path="/aziende"
                            element={
                                <PrivateRoute>
                                    <Clienti screenSize={screenSize} />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/utentiAziende"
                            element={
                                <PrivateRoute>
                                    <UtentiClienti screenSize={screenSize} />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/RiepilogativoVisite"
                            element={
                                <PrivateRoute>
                                    <RiepilogativoVisite
                                        screenSize={screenSize}
                                    />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/CollegaVirtuale"
                            element={
                                <PrivateRoute>
                                    <CollegaVirtuale screenSize={screenSize} />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/Adempimenti"
                            element={
                                <PrivateRoute>
                                    <Adempimenti screenSize={screenSize} />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/Attrezzature"
                            element={
                                <PrivateRoute>
                                    <Attrezzature screenSize={screenSize} />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/dettaglioLavoratore"
                            element={
                                <PrivateRoute>
                                    <DettaglioLavoratore
                                        screenSize={screenSize}
                                    />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/medici"
                            element={
                                <PrivateRoute>
                                    <Medici screenSize={screenSize} />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/dettaglioMedico"
                            element={
                                <PrivateRoute>
                                    <DettaglioMedico screenSize={screenSize} />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/Anomalie"
                            element={
                                <PrivateRoute>
                                    <Anomalie screenSize={screenSize} />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/visiteMediche"
                            element={
                                <PrivateRoute>
                                    <VisiteMediche screenSize={screenSize} />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/Allegato3B"
                            element={
                                <PrivateRoute>
                                    <Allegati3B screenSize={screenSize} />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/PrefatturazioneMedicina"
                            element={
                                <PrivateRoute>
                                    <PrefatturazioneMedicina
                                        screenSize={screenSize}
                                    />
                                </PrivateRoute>
                            }
                        />

                        <Route
                            path="/AnagraficaCorsi"
                            element={
                                <PrivateRoute>
                                    <AnagraficaCorsi screenSize={screenSize} />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/AuleCorsi"
                            element={
                                <PrivateRoute>
                                    <AuleCorsi screenSize={screenSize} />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/LavoratoriSicurezza"
                            element={
                                <PrivateRoute>
                                    <LavoratoriSicurezza
                                        screenSize={screenSize}
                                    />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/CorsiAttestati"
                            element={
                                <PrivateRoute>
                                    <CorsiAttestati screenSize={screenSize} />
                                </PrivateRoute>
                            }
                        />

                        <Route
                            path="/PrefatturazioneCorsi"
                            element={
                                <PrivateRoute>
                                    <PrefatturazioneCorsi
                                        screenSize={screenSize}
                                    />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/Formatori"
                            element={
                                <PrivateRoute>
                                    <Formatori screenSize={screenSize} />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/Scadenzario"
                            element={
                                <PrivateRoute>
                                    <Scadenzario screenSize={screenSize} />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/AndamentoELearning"
                            element={
                                <PrivateRoute>
                                    <AndamentoELearning
                                        screenSize={screenSize}
                                    />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/DiagnosticaELearning"
                            element={
                                <PrivateRoute>
                                    <DiagnosticaELearning
                                        screenSize={screenSize}
                                    />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/ScadenzarioMedicina"
                            element={
                                <PrivateRoute>
                                    <ScadenzarioVisite
                                        screenSize={screenSize}
                                    />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/Memo"
                            element={
                                <PrivateRoute>
                                    <Memo screenSize={screenSize} />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/MansioniSicurezza"
                            element={
                                <PrivateRoute>
                                    <MansioniSicurezza
                                        screenSize={screenSize}
                                    />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/CategoriaAdempimenti"
                            element={
                                <PrivateRoute>
                                    <CategoriaAdempimenti
                                        screenSize={screenSize}
                                    />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/AnagraficaRischi"
                            element={
                                <PrivateRoute>
                                    <AnagraficaRischi screenSize={screenSize} />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/AnagraficaAccertamenti"
                            element={
                                <PrivateRoute>
                                    <AnagraficaAccertamenti
                                        screenSize={screenSize}
                                    />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/AnagraficaMansioni"
                            element={
                                <PrivateRoute>
                                    <AnagraficaMansioni
                                        screenSize={screenSize}
                                    />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/RiepilogativoFormazione"
                            element={
                                <PrivateRoute>
                                    <RiepilogativoFormazione
                                        screenSize={screenSize}
                                    />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/AnagraficheDPI"
                            element={
                                <PrivateRoute>
                                    <AnagraficheDPI screenSize={screenSize} />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/Miglioramenti"
                            element={
                                <PrivateRoute>
                                    <Miglioramenti screenSize={screenSize} />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/TipologiePrestazioni"
                            element={
                                <PrivateRoute>
                                    <TipologiePrestazioni
                                        screenSize={screenSize}
                                    />
                                </PrivateRoute>
                            }
                        />
                    </Route>
                    <Route
                        path="/Idoneita"
                        element={
                            <PrivateRoute>
                                <Idoneita screenSize={screenSize} />
                            </PrivateRoute>
                        }
                    />
                    {
                        //#endregion
                    }
                    <Route path="*" element={<NotFoundPage />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
};

export default App;

const NotFoundPage = () => {
    return (
        <div
            style={{
                height: '100vh',
                backgroundColor: '#11526F',
                paddingTop: '20%',
                paddingBottom: '20%',
            }}
        >
            <center>
                <h1 style={{ color: 'white', fontSize: 100 }}>404</h1>
                <h3 style={{ color: 'white' }}>PAGINA NON TROVATA</h3>
                <p>
                    <Link to="/" style={{ color: 'white' }}>
                        HOMEPAGE
                    </Link>
                </p>
            </center>
        </div>
    );
};
